const RandomAlphaNumeric = (len) => {

    // var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var randomChars = '';
    var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; //exclude : I, O, 1, 0
    for (let i = 0; i < len; i++) {
        var randomIndex = Math.floor(Math.random() * alphabet.length);
        randomChars += alphabet[randomIndex];
    }
    return (randomChars);
};
export default RandomAlphaNumeric;